import BaseAPI from "../base";
import { getStorageExpire, setStorageExpire } from "@/utils/utils";
import { CONFIG_STORAGE } from "@/constants/storage";

class MeetingService extends BaseAPI {
  // HIS客户信息检索
  getCalendar(params) {
    return this.post({
      url: "/YuanHe/Meeting/Calendar",
      data: params,
    });
  }
  // 渠道
  getChannels(params) {
    return this.post({
      url: "/YuanHe/Meeting/Channels",
      data: params,
    });
  }
  // 新增预约记录
  bookingAdd(params) {
    return this.post({
      url: "/YuanHe/Meeting/BookingAdd",
      data: params,
    });
  }
  // 我的预约
  getBookingList(params) {
    return this.post({
      url: "/YuanHe/Meeting/BookingList",
      data: params,
    });
  }
  // 预约详情
  getBookingDetail(params) {
    return this.post({
      url: "/YuanHe/Meeting/BookingDetail",
      data: params,
    });
  }
  // 取消日程
  bookingCancel(params) {
    return this.post({
      url: "/YuanHe/Meeting/BookingCancel",
      data: params,
    });
  }
  // 专家列表
  getExpertList(params) {
    return this.post({
      url: "/YuanHe/Meeting/ExpertList",
      data: params,
    });
  }
  // 统计数据
  getMeetingStatisticData(params) {
    return this.post({
      url: "/YuanHe/Meeting/MeetingStatisticData",
      data: params,
    });
  }
  // 统计选项
  getMeetingStatisticOption(params) {
    return this.post({
      url: "/YuanHe/Meeting/MeetingStatisticOption",
      params,
    });
  }

  //
  exportExcel(params) {
    return this.post({
      url: "/YuanHe/Meeting/ExportExcel",
      data: {
        ...params,
      },
      responseType: "blob",
    });
  }

  //
  JOB_SYNC_INFO() {
    return this.get({
      url: "/api/Meeting/JOB_SYNC_INFO",
      params: {
        key: "Meeting666",
      },
    });
  }

  // 会议室信息
  getMeetingRooms() {
    return new Promise((resolve) => {
      let result = getStorageExpire(CONFIG_STORAGE.MEETING_ROOMS);
      let workVersion = getStorageExpire(CONFIG_STORAGE.WORK_VERSION);
      if (workVersion < CONFIG_STORAGE.currentVersion) {
        setStorageExpire(
          CONFIG_STORAGE.WORK_VERSION,
          CONFIG_STORAGE.currentVersion
        );
        result = null;
      }

      if (result) resolve(result);
      else {
        this.post({
          url: "/YuanHe/Meeting/MeetingRooms",
          params: {
            ding_user_id: "123",
          },
        }).then((res) => {
          setStorageExpire(CONFIG_STORAGE.MEETING_ROOMS, res, 60 * 24);
          resolve(res);
        });
      }
    });
  }
}

export default new MeetingService();
